/**
 * Persist per-post minimized club thread comment IDs (localStorage).
 * Key: clubThreadMinimized:${postId} → JSON { ids: number[] } (FIFO queue; oldest dropped at cap).
 */

export const CLUB_THREAD_MINIMIZED_KEY_PREFIX = "clubThreadMinimized:";
export const CLUB_THREAD_MINIMIZED_MAX_IDS = 120;

function storageKey(postId) {
  return `${CLUB_THREAD_MINIMIZED_KEY_PREFIX}${Number(postId)}`;
}

function parseStoredIds(raw) {
  if (raw == null || raw === "") return [];
  try {
    const o = JSON.parse(raw);
    const ids = Array.isArray(o?.ids) ? o.ids : Array.isArray(o) ? o : [];
    return ids.map(Number).filter((n) => Number.isFinite(n));
  } catch {
    return [];
  }
}

/** Ordered queue: oldest at index 0 (evicted first when over cap). */
export function readMinimizedIdQueue(postId) {
  if (typeof window === "undefined") return [];
  const pid = Number(postId);
  if (!Number.isFinite(pid)) return [];
  try {
    return parseStoredIds(window.localStorage.getItem(storageKey(pid)));
  } catch {
    return [];
  }
}

function writeQueue(postId, ids) {
  if (typeof window === "undefined") return;
  const pid = Number(postId);
  if (!Number.isFinite(pid)) return;
  const key = storageKey(pid);
  try {
    if (!ids.length) {
      window.localStorage.removeItem(key);
    } else {
      window.localStorage.setItem(key, JSON.stringify({ ids }));
    }
  } catch {
    /* quota or private mode */
  }
}

/**
 * @param {{ postId: number, commentId: number, minimized: boolean }} p
 */
export function persistClubThreadMinimized({ postId, commentId, minimized }) {
  const pid = Number(postId);
  const cid = Number(commentId);
  if (!Number.isFinite(pid) || !Number.isFinite(cid)) return;

  let queue = readMinimizedIdQueue(pid);
  if (minimized) {
    queue = queue.filter((id) => id !== cid);
    queue.push(cid);
    while (queue.length > CLUB_THREAD_MINIMIZED_MAX_IDS) {
      queue.shift();
    }
  } else {
    queue = queue.filter((id) => id !== cid);
  }
  writeQueue(pid, queue);
}

export function isMinimizedInStorage(postId, commentId) {
  const cid = Number(commentId);
  if (!Number.isFinite(cid)) return false;
  return readMinimizedIdQueue(postId).includes(cid);
}
